import Http from "../utils/Http";
import { getExpirationDate, getBrowserFingerprint } from "../utils/common-utils";

export const sendOTP = async (mobileNumber, countryCode) => {
  let data = {
    phoneNumber: `${countryCode}${mobileNumber}`,
  };
  let res = await Http.post(`co-teacher/users/login`, data);
  return res;
};
export const verifyOTP = async (userName, code, session) => {
  let data = {
    userName: userName,
    code: code,
    session: session,
  };
  let res = await Http.post(`co-teacher/users/verify`, data);
  return res;
};
export const updateUserName = async (userName) => {
  try {
    let data = {
      name: userName,
    };
    let res = await Http.put(`co-teacher/users/update-status`, data);
    return res;
  } catch (e) {
    console.error(e);
    return;
  }
};

export const userLogout = async () => {
  let res = await Http.post(`co-teacher/users/logout`);
  return res;
};

export const saveSchoolEnquiry = async (body) => {
  let res = await Http.post(`co-teacher/school-enquiry`, body);
  return res;
};
export const SendOTPForSchoolEnquiry = async (mobileNumber) => {
  let body = {
    phoneNumber: `+91${mobileNumber}`,
  };
  let res = await Http.post(`co-teacher/school-enquiry/login`, body);
  return res;
};

export const VerifyForSchoolEnquiry = async (data, code) => {
  let body = {
    userName: data?.authId || "",
    code: code,
    session: data?.session || "",
  };
  let res = await Http.post(`co-teacher/school-enquiry/verify`, body);
  return res;
};

export const handleRefreshToken = async (refreshToken) => {
  return new Promise(async (resolve) => {
    try {
      const axios = (await import("axios")).default;
      const customHeaders = {
        refreshtoken: refreshToken,
      };
      axios
        .post(
          import.meta.env.VITE_API_URL + "co-teacher/users/tokens",
          {},
          {
            headers: customHeaders,
          },
        )
        .then(async (response) => {
          let expiresIn, idToken;
          if (response?.data) {
            ({ expiresIn, idToken } = response.data);
          }
          let savedData = await localStorage.getItem("userInfo");
          try {
            savedData = JSON.parse(savedData);
          } catch (e) {
            console.error(e);
            savedData = {};
          }
          savedData = savedData || {};
          savedData = {
            ...savedData,
            idToken,
            expirationDate: getExpirationDate(expiresIn),
          };
          await localStorage.setItem("userInfo", JSON.stringify(savedData));
          await localStorage.setItem("token", idToken);
          resolve(response?.data); // Resolve with the response data
        })
        .catch((error) => {
          console.error("Bad Request:", error.response?.data);
          resolve(); // Resolve without any data
        });
    } catch (e) {
      console.error(e);
    }
  });
};



export const fetchAiReadinessData = async () => {
  let res = await Http.get(`co-teacher/ai-readiness/data`);
  return res;
};

export const submitAiReadiness = async (formData, userResponses) => {
  const payload = {
    form_data: {
      name: formData.yourName,
      phoneNumber: formData.mobileNumber,
      email: formData.email,
      schoolName: formData.schoolName,
      city: formData.city,
      designation: formData.designation,
      challenges: formData.challenges || null,
      otherDesignation: formData.otherDesignation || null
    },
    user_responses: userResponses
  };
  let res = await Http.post(`co-teacher/ai-readiness/submit`, payload);
  return res;
};


export const saveKrishnaAiConv = async (convId, status = 'in-progress') => {
  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    const token = localStorage.getItem("token");
    const userId = userInfo?.userId;

    // Use external referrer if available, otherwise use document.referrer
    const externalRef = localStorage.getItem("externalRef");
    const referrer = externalRef || document.referrer || "";

    const headers = {
      "Content-Type": "application/json",
      "x-user-id": userId,
      "Authorization": token,
      "browser-signature": await getBrowserFingerprint(),
      "origin": window.location.origin,
      "referrer": referrer,
      "user-agent": navigator.userAgent,
    };

    const response = await fetch(
      `${import.meta.env.VITE_API_URL}co-teacher/krishna-ai-conversation`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          conversation_id: convId,
          status: status
        }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      return { success: false, data };
    }

    return { success: true, data };
  } catch (error) {
    console.error('Error saving Krishna AI conversation:', error);
    return { success: false, error };
  }
};

export const saveContactUsForm = async(formData)=>
{
  const payload=formData;
  let res= await Http.post(`co-teacher/contact-us`,payload);
  return res;
}
